import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function StillInTheDark() {
  return <section data-section-id="235248" id="still-in-the-dark" className="bg-background text-foreground">
      <Link to="/FlightDeckPage" className="group flex w-full items-center justify-center gap-4 bg-secondary py-12 px-6 transition-all duration-500 hover:bg-secondary/90 sm:py-16">
        <div className="flex flex-col items-center gap-2 sm:flex-row sm:gap-8">
          <span className="font-default text-lg font-medium tracking-wider text-foreground/80 uppercase sm:text-xl">
            Technical Questions? Contact Comms Directly.
          </span>
          <span className="font-default text-4xl font-bold tracking-tighter text-primary sm:text-5xl md:text-6xl">
            888-370-2846
          </span>
        </div>
        <div className="flex items-center gap-2 rounded-md bg-primary px-4 py-2 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-primary/20">
          <span className="font-default text-sm font-bold uppercase tracking-widest text-primary-foreground">
            Direct Email
          </span>
          <ArrowRight className="size-4 text-primary-foreground transition-all duration-500 group-hover:translate-x-1 sm:size-5" />
        </div>
      </Link>
    </section>;
}